"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var LAYOUT = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical'
};
/**
 * RadioGroup used to group Radio components.
 */

var RadioGroup =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RadioGroup, _React$Component);

  function RadioGroup() {
    _classCallCheck(this, RadioGroup);

    return _possibleConstructorReturn(this, _getPrototypeOf(RadioGroup).apply(this, arguments));
  }

  _createClass(RadioGroup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          selectedValue = _this$props.selectedValue,
          children = _this$props.children,
          onChange = _this$props.onChange,
          name = _this$props.name,
          disabled = _this$props.disabled,
          layout = _this$props.layout,
          props = _objectWithoutProperties(_this$props, ["className", "selectedValue", "children", "onChange", "name", "disabled", "layout"]);

      if (_react.default.Children.count(children) < 2) {
        throw new Error('RadioGroup children must contains 2 or more Radio elements');
      }

      var formattedChildren = _react.default.Children.map(children, function (child) {
        if (child.props.componentDisplayName !== 'Radio') {
          throw new Error('RadioGroup children must be of type Radio');
        } // Radio.props.value must be set.


        if (typeof child.props.value !== 'string') {
          throw new Error('Radio value property must be defined and unique.');
        }

        var radioProps = {
          onChange: onChange,
          name: name
        };
        /**
         * This check is needed because if it is undefined
         * then we keep the child(Radio) disabled props unchanged.
         */

        if (typeof disabled !== 'undefined') {
          radioProps.disabled = disabled;
        }
        /**
         * For horizontal layout override the child(Radio).additionalInfo props
         * because additionalInfo is only allowed in vertical mode.
         */


        if (layout === LAYOUT.HORIZONTAL) {
          radioProps.additionalInfo = undefined;
        }

        if (child.props.value === selectedValue) {
          return _react.default.cloneElement(child, _objectSpread({}, radioProps, {
            checked: true
          }));
        }

        return _react.default.cloneElement(child, _objectSpread({}, radioProps, {
          checked: false
        }));
      });

      return _react.default.createElement(_FlexLayout.default, _extends({
        className: (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), "-radio-group")),
        flexDirection: layout === LAYOUT.HORIZONTAL ? 'row' : 'column'
      }, props), formattedChildren);
    }
  }]);

  return RadioGroup;
}(_react.default.Component);

exports.default = RadioGroup;
RadioGroup.LAYOUT = LAYOUT;
RadioGroup.defaultProps = {
  selectedValue: ''
};
RadioGroup.propTypes = {
  /**
   * Custom class name append to the component.
   */
  className: _propTypes.default.string,

  /**
   * All child should be of type Radio.
   * Each Radio component must provide props.value and should be unique.
   * Required minimum of 2 Radio children.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * The currently selected Radio matched this value.
   */
  selectedValue: _propTypes.default.string.isRequired,

  /**
   * Callback when a new Radio selection is made.
   * onChange(nextSelectedValue)
   */
  onChange: _propTypes.default.func.isRequired,

  /**
   * The group name.  This should be unique if there are multiple RadioGroup
   * on a page.
   */
  name: _propTypes.default.string,

  /**
   * Disable all radio buttons.  Note if this is defined, it will override
   * all children disabled property.
   */
  disabled: _propTypes.default.bool,

  /**
   * Do not use horizontal layout unless space is an issue.
   * In horizontal layout any child(Radio) contains additionalInfo props
   * will be removed.
   */
  layout: _propTypes.default.oneOf([LAYOUT.HORIZONTAL, LAYOUT.VERTICAL])
};